var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenerationalWealthSocietyLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3571 40.59C37.602 38.393 42.8571 31.858 42.8571 24.1379C42.8571 14.6158 34.8622 6.89655 25 6.89655C15.1378 6.89655 7.14286 14.6158 7.14286 24.1379C7.14286 31.858 12.398 38.393 19.6429 40.59V50H0V43.1034H9.53358C3.72739 38.6833 0 31.8309 0 24.1379C0 10.8069 11.1929 0 25 0C38.8071 0 50 10.8069 50 24.1379C50 31.8309 46.2726 38.6833 40.4664 43.1034H50V50H30.3571V40.59Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerationalWealthSocietyLogo);
export default __webpack_public_path__ + "static/media/GenerationalWealthSociety Logo.c93ee5f2.svg";
export { ForwardRef as ReactComponent };